export default __webpack_public_path__ + "static/long_rectangle_shadow_wwf-40d226e2429ae55c9ef7504aa0729fef.gif";